import axios from "axios"
import router from "@/router"
// import store from '@/store'
//import { AUTH_ERROR } from '@/store/types'

axios.defaults.withCredentials = true

const baseURL = process.env.VUE_APP_BASE_URI || "http://localhost:8000"

const instance = axios.create({
  baseURL
})

instance.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token")

    // Only include token to backend API
    if (token && (!config.url.includes("http") || config.url.includes(baseURL))) {
      config.headers["Authorization"] = `Bearer ${token}`
    }

    if (config.url.includes(".html")) {
      config.baseURL = location.origin
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      router.currentRoute._value.matched.some((route) => route.meta.requireAuth)
    ) {
      router.push({ name: "home_login" })
    }
    return Promise.reject(error)
    /*
    if (error.response.status === 401 && router.currentRoute._value.matched.some(route => route.meta.auth)) {
      router.push({ name: "login" });
      return Promise.resolve(error.response);
    } else if (error.response.status === 403) {
      // 403 Forbidden Error
      router.push({ name: "403" });
      return Promise.resolve(error.response);
    } else if (error.response.status === 404) {
      // 404 Not Found Error
      router.push({ name: "404" });
      return Promise.resolve(error.response);
    } else if (error.response.status >= 500) {
      // 500 Server Error
      router.push({ name: "500" });
      return Promise.resolve(error.response);
    } else {
      return Promise.reject(error);
    }
    */
  }
)

export default instance
